import { render, staticRenderFns } from "./NAO_Promociones.vue?vue&type=template&id=651445a0&"
import script from "./NAO_Promociones.vue?vue&type=script&lang=js&"
export * from "./NAO_Promociones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports